import {
  PRODUCT_LISTING_RECEIVE,
  PRODUCT_LISTING_SET_PROP,
  PRODUCT_LISTING_SET_IS_LOADING,
  PRODUCT_LISTING_SET_PRODUCTS,
  PRODUCT_LISTING_SET_URL_COUNT,
  PRODUCT_LISTING_SET_SHOW_ROOM_IMAGE,
} from '../constants';
import { RootState } from '../reducers';
import { get, post } from '../Services/http';
import Product from '../Types/Product';
import { getProductFilteringAsQueryString } from './ProductFiltering.action';

export const fetchProducts =
  (startIndex: number, take?: number, abortController?: AbortController) =>
  async (dispatch, getState: () => RootState): Promise<undefined> => {
    dispatch(setIsLoadingMore(true));
    const productListingState = getState().productListing;
    const { totalProductsCount, fromCount, pageSize } =
      productListingState;
    const productFiltering = getState().productFiltering;
    try {
      // Calculate number of products to skip and take
      const skip = startIndex;
      if (!take) {
        take = pageSize;
      }

      // Make sure we don't take more than what's left until we reach totalProductsCount
      if (skip + take > totalProductsCount) {
        take = totalProductsCount - skip;
      }

      const filterParams =
        getProductFilteringAsQueryString(productFiltering);
      const response = await get(
        `/api/products?skip=${skip}&take=${take}&${filterParams}`,
        abortController
      );
      const newProductListing = await response.json();

      // Replace placeholder cards with the actual products
      let _products: Product[];
      if (fromCount && fromCount > 0 && skip < fromCount) {
        _products = [...getState().productListing.products];
        _products.splice(skip, take, ...newProductListing.products);
      } else {
        _products = [
          ...getState().productListing.products,
          ...newProductListing.products,
        ];
      }

      dispatch(setProducts(_products, newProductListing.gtmViewModel));
    } catch (err) {
      // TODO Error handling, retry once or twice? Not in MOX-86
      // If retry, we need to move setIsLoadingMore(false) to both "try" and "catch", instead of "finally"
      console.log(err);
      throw err;
    } finally {
      dispatch(setIsLoadingMore(false));
    }
    return undefined;
  };

export const receiveProductListing = (productListing) => ({
  type: PRODUCT_LISTING_RECEIVE,
  payload: productListing,
});

const setProductListingProp = (key, value) => ({
  type: PRODUCT_LISTING_SET_PROP,
  payload: {
    [key]: value,
  },
});

export const setLoadMoreFrom = (loadMoreFrom) => (dispatch) =>
  dispatch(setProductListingProp('loadMoreFrom', loadMoreFrom));

export const setLoadReverseFrom = (loadReverseFrom) => (dispatch) =>
  dispatch(setProductListingProp('loadReverseFrom', loadReverseFrom));

export const setIsLoadingReverse = (isLoadingReverse) => (dispatch) =>
  dispatch(setProductListingProp('isLoadingReverse', isLoadingReverse));

export const setIsLoadingMore = (isLoadingMore) => (dispatch) =>
  dispatch(setProductListingProp('isLoadingMore', isLoadingMore));

export const setScrollIndex = (scrollIndex) => (dispatch) =>
  dispatch(setProductListingProp('scrollIndex', scrollIndex));

export const setTotalProductsCount = (totalProductsCount) => (dispatch) =>
  dispatch(
    setProductListingProp('totalProductsCount', totalProductsCount)
  );

export const setProductsPerRow = (productsPerRow) => (dispatch) =>
  dispatch(setProductListingProp('productsPerRow', productsPerRow));

export const setProducts = (products, gtmViewModel = null) => ({
  type: PRODUCT_LISTING_SET_PRODUCTS,
  payload: {
    products,
    gtmViewModel,
  },
});

export const setProductListingType =
  (productListingType) => async (dispatch) => {
    const res = await post('/api/products/listingtype', {
      productListingType,
    });
    if (res.ok) {
      dispatch(
        setProductListingProp('productListingType', productListingType)
      );
    }
  };

export const setIsLoadingProductListing = (isLoading) => ({
  type: PRODUCT_LISTING_SET_IS_LOADING,
  payload: {
    isLoading,
  },
});

export const setUrlCount = (count: number) => ({
  type: PRODUCT_LISTING_SET_URL_COUNT,
  payload: {
    count,
  },
});

export const setShowRoomImage = (showRoomImage: boolean) => ({
  type: PRODUCT_LISTING_SET_SHOW_ROOM_IMAGE,
  payload: {
    showRoomImage,
  },
});
